import React from 'react';
import './Experience.css'
function Experience() {
    return (
        <div style={{ margin: '5rem 0',backgroundColor: 'white', }}>
        <h2 style={{ fontSize: '2rem', fontWeight: 'bold' }}>PROFESSIONAL EXPERIENCE</h2>
  
        <div style={{ borderBottom: '2px solid #ddd', paddingBottom: '1rem' }}>
    <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Refactor Academy, Bangalore, India</h3>
    <p style={{ fontWeight: 'bold' }}>FULL STACK DEVELOPER/INTERNSHIP<span style={{ color: '#999', marginLeft: '1rem' }}>(Nov 2022 - Present)</span></p>
    <ul>
      <li>Developed Front end website architecture using React framework.</li>
      <li>Developed Backend website applications using Nodejs and ExpressJs.</li>
      <li>Good Understanding of Data Structure and Algorithm.</li>
      <li>Designed user interactions on web pages.</li>
      <li>Seeing through a project from conception to finished product.</li>
    </ul>
  </div>
  
  <div style={{ borderBottom: '2px solid #ddd', paddingBottom: '1rem' }}>
    <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Way2Agribusiness India Pvt.Ltd, Bangalore, India</h3>
    <p style={{ fontWeight: 'bold' }}>BACKEND DEVELOPER/PART-TIME JOB<span style={{ color: '#999', marginLeft: '1rem' }}>(Jan 2023 - MARCH 2023)</span></p>
    <ul>
      <li>Developed Front end website architecture using Angular framework.</li>
      <li>Developed E-commerce website applications using MERN stack.</li>
      <li>Good Understanding of NodeJs.</li>
      <li>Designed user interactions on web pages.</li>
      <li>Seeing through a project from conception to finished product.</li>
    </ul>
  </div>
  <div style={{ borderBottom: '2px solid #ddd', paddingBottom: '1rem' }}>
    <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>LEADICS, Bangalore, India</h3>
    <p style={{ fontWeight: 'bold' }}>FULL STACK DEVELOPER/INTERNSHIP<span style={{ color: '#999', marginLeft: '1rem' }}>(Apr 2022 - Jun 2022)</span></p>
    <ul>
      <li>Developed Front end website architecture using Angular framework.</li>
      <li>Developed Backend website applications using Java programming language.</li>
      <li>Good Understanding of Data Structure and Algorithm.</li>
      <li>Designed user interactions on web pages.</li>
      <li>Seeing through a project from conception to finished product.</li>
    </ul>
  </div>
  <div style={{ borderBottom: '2px solid #ddd', paddingBottom: '1rem' }}>
    <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>SUVIDHA FOUNDATION, Bangalore, India</h3>
    <p style={{ fontWeight: 'bold' }}>PROGRAMMING TUTOR<span style={{ color: '#999', marginLeft: '1rem' }}>(Nov 2021 - Jan 2022)</span></p>
  </div>
  <div style={{ borderBottom: '2px solid #ddd', paddingBottom: '1rem' }}>
<h3 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>BLITZ JOBS, Bangalore, India</h3>
<p style={{ fontWeight: 'bold' }}>GRAPHICS INTERNSHIP<span style={{ color: '#999', marginLeft: '1rem' }}>(Sep 2021 - Nov 2021)</span></p>
  </div>
  <div style={{ borderBottom: '2px solid #ddd', paddingBottom: '1rem' }}>
<h3 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>SuccessR (3 MONTHS) BANGALORE, INDIA</h3>
<p style={{ fontWeight: 'bold' }}>GRAPHICS INTERNSHIP<span style={{ color: '#999', marginLeft: '1rem' }}>(JULY 2021-OCTOBER 2021)</span></p>
  </div>
      </div>
    );
}

export default Experience;
